
import { platform } from '@helpers/Constants';
import { getIOSVersion, getAndroidVersion } from '@helpers/Common';
import userStore from '@stores/user';
import axios, { AxiosResponse } from 'axios';
import { IApiSourceParams, IApiSourceResponse } from '@apis/client';

//操作系统
let operatingSystem = navigator.userAgent;
if(platform.android) {
  operatingSystem = 'Android ' + getAndroidVersion();
} else if(platform.ios) {
  operatingSystem = 'IOS ' + getIOSVersion();
}

interface Response<T> {
  data: T;
  message: string;
  statusCode: number;
}

export type IRequestParams = Record<string, any>;

const log = async (params: any, componentStack?: string, ) => {
  const os = operatingSystem;
  const logParams: IRequestParams = {
    name: params.name,
    message: params.message || '',
    stacks: [],
    userAgent: navigator.userAgent,
    os,
    type: params.type,
    extra: params.extra
  };

  if(userStore?.userInfo) {
    logParams.userUid = userStore.userInfo.uid;
    logParams.phone = userStore.userInfo.phone;
  }
  if(componentStack) {
    componentStack.split('\n').forEach(function(str) {
      const stack = str.trim();
      if(stack) {
        logParams.stacks.push(stack);
      }
    });
    logParams.stacks.reverse();
  }

  await axios
    .post<
      IApiSourceParams,
      AxiosResponse<Response<IApiSourceResponse>>
    >(`${window.PUBLIC_URL}/log`, logParams, {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    })
    .catch(e => {
      throw new Error('ERROR_REPORT_REQUEST');
    });
}

export default  {
  log
};